// The following eslint-disable was automated from the ts conversion
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react'
import ResourceFormPage from './ResourceFormPage'
import EditRegistrationForm from './EditRegistrationForm'

/* @ts-expect-error auto-src: noflow */
const EditRegistration = (props) => (
  <ResourceFormPage {...props}>{EditRegistrationForm}</ResourceFormPage>
)

export default EditRegistration
